import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_232c5c28 from 'nuxt_plugin_plugin_232c5c28' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_359cd90e from 'nuxt_plugin_pluginutils_359cd90e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_151b2684 from 'nuxt_plugin_pluginrouting_151b2684' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_60cef36b from 'nuxt_plugin_pluginmain_60cef36b' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_51df1e58 from 'nuxt_plugin_gtm_51df1e58' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_90b301fc from 'nuxt_plugin_axios_90b301fc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_autoreordersetupclient_66882784 from 'nuxt_plugin_autoreordersetupclient_66882784' // Source: ../plugins/autoreorder-setup.client.js (mode: 'client')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe' // Source: ../plugins/cookies.js (mode: 'all')
import nuxt_plugin_logging_9eae03a4 from 'nuxt_plugin_logging_9eae03a4' // Source: ../plugins/logging.js (mode: 'all')
import nuxt_plugin_splitAPIclient_5c837874 from 'nuxt_plugin_splitAPIclient_5c837874' // Source: ../plugins/splitAPI.client.js (mode: 'client')
import nuxt_plugin_vuedatepicker_3b882067 from 'nuxt_plugin_vuedatepicker_3b882067' // Source: ../plugins/vue-date-picker.js (mode: 'client')
import nuxt_plugin_vueslickcarousel_1c6345a5 from 'nuxt_plugin_vueslickcarousel_1c6345a5' // Source: ../plugins/vue-slick-carousel.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_dynamiccurrency_77026482 from 'nuxt_plugin_dynamiccurrency_77026482' // Source: ../plugins/dynamic-currency.js (mode: 'all')
import nuxt_plugin_dynamicurls_9ef45662 from 'nuxt_plugin_dynamicurls_9ef45662' // Source: ../plugins/dynamic-urls.js (mode: 'all')
import nuxt_plugin_braintree_65846859 from 'nuxt_plugin_braintree_65846859' // Source: ../plugins/braintree.js (mode: 'all')
import nuxt_plugin_patchboard_8afeb43a from 'nuxt_plugin_patchboard_8afeb43a' // Source: ../plugins/patchboard.js (mode: 'all')
import nuxt_plugin_gtm_63638066 from 'nuxt_plugin_gtm_63638066' // Source: ../plugins/gtm.js (mode: 'all')
import nuxt_plugin_livechat_432633fd from 'nuxt_plugin_livechat_432633fd' // Source: ../plugins/livechat.js (mode: 'all')
import nuxt_plugin_browserTestclient_4855d382 from 'nuxt_plugin_browserTestclient_4855d382' // Source: ../plugins/browserTest.client.js (mode: 'client')
import nuxt_plugin_compositionapi_a8f56dd4 from 'nuxt_plugin_compositionapi_a8f56dd4' // Source: ../plugins/composition-api.js (mode: 'all')
import nuxt_plugin_piniacore_420679e2 from 'nuxt_plugin_piniacore_420679e2' // Source: ../plugins/pinia-core.js (mode: 'all')
import nuxt_plugin_piniaconsolidated_216bf006 from 'nuxt_plugin_piniaconsolidated_216bf006' // Source: ../plugins/pinia-consolidated.js (mode: 'all')
import nuxt_plugin_auth_a25f7c24 from 'nuxt_plugin_auth_a25f7c24' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_appmountedclient_25d38b9a from 'nuxt_plugin_appmountedclient_25d38b9a' // Source: ../plugins/app-mounted.client.js (mode: 'client')
import nuxt_plugin_auth_8fed78d0 from 'nuxt_plugin_auth_8fed78d0' // Source: ../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Contact Lenses | Next Day UK Delivery | Lenstore","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fpng","href":"\u002Fapple-touch-icon.png"},{"rel":"preconnect","href":"https:\u002F\u002Fsdk.split.io"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fsdk.split.io"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.googletagmanager.com"},{"rel":"preconnect","href":"https:\u002F\u002Fcookie-cdn.cookiepro.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcookie-cdn.cookiepro.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com"},{"hid":"assets-preconnect","rel":"preconnect","href":"https:\u002F\u002Fassets.lenstore.co.uk"},{"hid":"assets-dns-preconnect","rel":"dns-prefetch","href":"https:\u002F\u002Fassets.lenstore.co.uk"}],"script":[{"hid":"gtmConsentDefaults","type":"text\u002Fjavascript","charset":"UTF-8","innerHTML":";\n    window.dataLayer = window.dataLayer || [];\n    function gtag() {\n      dataLayer.push(arguments);\n    }\n\n    gtag('consent', 'default', {\n      security_storage: 'granted',\n      ad_storage: 'denied',\n      ad_personalization: 'denied',\n      ad_user_data: 'denied',\n      analytics_storage: 'denied',\n      personalization_storage: 'denied',\n      functionality_storage: 'denied',\n      wait_for_update: 500,\n    });"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"gtmConsentDefaults":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_232c5c28 === 'function') {
    await nuxt_plugin_plugin_232c5c28(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_359cd90e === 'function') {
    await nuxt_plugin_pluginutils_359cd90e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_151b2684 === 'function') {
    await nuxt_plugin_pluginrouting_151b2684(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_60cef36b === 'function') {
    await nuxt_plugin_pluginmain_60cef36b(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_51df1e58 === 'function') {
    await nuxt_plugin_gtm_51df1e58(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_90b301fc === 'function') {
    await nuxt_plugin_axios_90b301fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_autoreordersetupclient_66882784 === 'function') {
    await nuxt_plugin_autoreordersetupclient_66882784(app.context, inject)
  }

  if (typeof nuxt_plugin_cookies_2c3cf8fe === 'function') {
    await nuxt_plugin_cookies_2c3cf8fe(app.context, inject)
  }

  if (typeof nuxt_plugin_logging_9eae03a4 === 'function') {
    await nuxt_plugin_logging_9eae03a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_splitAPIclient_5c837874 === 'function') {
    await nuxt_plugin_splitAPIclient_5c837874(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedatepicker_3b882067 === 'function') {
    await nuxt_plugin_vuedatepicker_3b882067(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslickcarousel_1c6345a5 === 'function') {
    await nuxt_plugin_vueslickcarousel_1c6345a5(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_dynamiccurrency_77026482 === 'function') {
    await nuxt_plugin_dynamiccurrency_77026482(app.context, inject)
  }

  if (typeof nuxt_plugin_dynamicurls_9ef45662 === 'function') {
    await nuxt_plugin_dynamicurls_9ef45662(app.context, inject)
  }

  if (typeof nuxt_plugin_braintree_65846859 === 'function') {
    await nuxt_plugin_braintree_65846859(app.context, inject)
  }

  if (typeof nuxt_plugin_patchboard_8afeb43a === 'function') {
    await nuxt_plugin_patchboard_8afeb43a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_63638066 === 'function') {
    await nuxt_plugin_gtm_63638066(app.context, inject)
  }

  if (typeof nuxt_plugin_livechat_432633fd === 'function') {
    await nuxt_plugin_livechat_432633fd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_browserTestclient_4855d382 === 'function') {
    await nuxt_plugin_browserTestclient_4855d382(app.context, inject)
  }

  if (typeof nuxt_plugin_compositionapi_a8f56dd4 === 'function') {
    await nuxt_plugin_compositionapi_a8f56dd4(app.context, inject)
  }

  if (typeof nuxt_plugin_piniacore_420679e2 === 'function') {
    await nuxt_plugin_piniacore_420679e2(app.context, inject)
  }

  if (typeof nuxt_plugin_piniaconsolidated_216bf006 === 'function') {
    await nuxt_plugin_piniaconsolidated_216bf006(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_a25f7c24 === 'function') {
    await nuxt_plugin_auth_a25f7c24(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appmountedclient_25d38b9a === 'function') {
    await nuxt_plugin_appmountedclient_25d38b9a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_8fed78d0 === 'function') {
    await nuxt_plugin_auth_8fed78d0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
